import ApiResourceManager from '../ApiResourceManager';

export default class StatsManager extends ApiResourceManager {
  get = (data) =>
    this.request({
      method: 'POST',
      url: '/mobile-app/stats',
      data,
    });
}
